export enum HEALTH_CHECK_TYPE {
  modal = 'WIDGET_MODAL',
  widget = 'WIDGET',
}
